import { useEffect, useState, useMemo } from "react";

// Componentes
import TituloModulo from "../../../../componentsUI/estructura/tituloModulos/tituloModulo.js";
import BotonAccion from "../../../../componentsUI/formularios/button/BotonAction.js";
import { useVentasxMetodo } from "../../../../contexto/provider/VentasVistasContext.js";

import "./vistaTabla.css";

export default function TablaVentasXMetodo({ rowsPerPage = 8 }) {
  const { ventas, loading, error, listarVentasMetodo } = useVentasxMetodo();
  const [paginaActual, setPaginaActual] = useState(1);

  const limiteFilas = Math.min(rowsPerPage, 20);
  const totalPaginas = Math.ceil(ventas.length / limiteFilas);

  const datosPaginados = useMemo(() => {
    const inicio = (paginaActual - 1) * limiteFilas;
    const fin = inicio + limiteFilas;
    return ventas.slice(inicio, fin);
  }, [ventas, paginaActual, limiteFilas]);

  const cambiarPagina = (numero) => {
    if (numero >= 1 && numero <= totalPaginas) {
      setPaginaActual(numero);
    }
  };

  // los filtros que uses
  useEffect(() => {
    listarVentasMetodo({ rango: "hoy" });
  }, [listarVentasMetodo]);

  useEffect(() => {
    setPaginaActual(1);
  }, [ventas]);

  if (loading) return <p>Cargando ventas...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div >
      <TituloModulo titulo="Totales por método de pago" />
      <BotonAccion onClick={() => listarVentasMetodo({ fuerza: true })}>
        Cargar
      </BotonAccion>
      <div className="tabla-container">
        <div className="tabla-scroll">
        <table className="tabla-reporte">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Método</th>
              <th className="col-num">Cantidad</th>
              <th className="col-num col-total">Total</th>
            </tr>
          </thead>
          <tbody>
            {datosPaginados.length === 0 ? (
              <tr>
                <td colSpan="4">Sin registros</td>
              </tr>
            ) : (
              datosPaginados.map((fila, index) => (
                <tr key={`${fila.fecha_factura}-${fila.metodo_pago}-${index}`}>
                  <td>{fila.fecha_factura}</td>
                  <td>
                    {fila.metodo_pago?.charAt(0).toUpperCase() +
                      fila.metodo_pago?.slice(1)}
                  </td>
                  <td className="col-num">{fila.cantidad_ventas}</td>
                  <td className="col-num col-total">
                    {new Intl.NumberFormat("es-CO", {
                      style: "currency",
                      currency: "COP",
                      minimumFractionDigits: 0,
                    }).format(fila.total_por_metodo)}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        </div>
        <div className="paginacion">
          <button onClick={() => cambiarPagina(paginaActual - 1)}>←</button>
          <span>
            Página {paginaActual} de {totalPaginas || 1}
          </span>
          <button onClick={() => cambiarPagina(paginaActual + 1)}>→</button>
        </div>
      </div>
    </div>
  );
}
